import Joi from '@hapi/joi';
import { SendCommunicationSecondStepForm } from 'types';
import validate from '../validate';

type Params = {
  isReasonActive?: boolean;
  isOthersReason?: boolean;
  isSignatureActive?: boolean;
  isVolumeDelay?: boolean;
  isSubtitutionAndSchedule?: boolean;
  isDock?: boolean;
};

export const schema = (
  params: Params = {
    isReasonActive: true,
    isOthersReason: true,
    isVolumeDelay: false,
    isSubtitutionAndSchedule: false,
    isDock: false,
    isSignatureActive: true,
  }
) => {
  const isCommunicationContent = params.isVolumeDelay || params.isSubtitutionAndSchedule || params.isDock;
  return Joi.object<SendCommunicationSecondStepForm>({
    situationId: Joi.number().required().messages({
      'any.required': 'INCOMPLETE_ERROR',
    }),
    reasonId: params.isReasonActive
      ? Joi.number().required().messages({
          'any.required': 'INCOMPLETE_ERROR',
        })
      : Joi.optional(),
    otherReasonComplementary: params.isOthersReason
      ? Joi.string().required().messages({
          'any.required': 'INCOMPLETE_ERROR',
          'string.empty': 'INCOMPLETE_ERROR',
        })
      : Joi.optional(),
    mailObject: Joi.when(Joi.ref('communicationChannels'), {
      is: Joi.array().has(1),
      then: Joi.string().required().messages({
        'any.required': 'INCOMPLETE_ERROR',
        'string.empty': 'INCOMPLETE_ERROR',
      }),
    }),
    mailHeadband: Joi.when(Joi.ref('communicationChannels'), {
      is: Joi.array().has(1),
      then: Joi.string().required().messages({
        'any.required': 'INCOMPLETE_ERROR',
        'string.empty': 'INCOMPLETE_ERROR',
      }),
    }),
    communicationChannels: Joi.array(),
    communicationContent: isCommunicationContent
      ? Joi.array().items(
          Joi.object({
            arrivalShortCodeStation: Joi.string(),
            delay: params.isVolumeDelay
              ? Joi.string().required().messages({
                  'any.required': 'INCOMPLETE_ERROR',
                  'string.empty': 'INCOMPLETE_ERROR',
                })
              : Joi.optional(),
            newSchedule: params.isSubtitutionAndSchedule
              ? Joi.string().required().messages({
                  'any.required': 'INCOMPLETE_ERROR',
                  'string.empty': 'INCOMPLETE_ERROR',
                })
              : Joi.optional(),
            stationReplacement: params.isSubtitutionAndSchedule
              ? Joi.string().required().messages({
                  'any.required': 'INCOMPLETE_ERROR',
                  'string.empty': 'INCOMPLETE_ERROR',
                })
              : Joi.optional(),
            dock: params.isDock
              ? Joi.string().required().max(10).messages({
                  'any.required': 'INCOMPLETE_ERROR',
                  'string.empty': 'INCOMPLETE_ERROR',
                  'string.max': 'STRING_MAX_10_CHARACTERS',
                })
              : Joi.optional(),
          })
        )
      : Joi.array(),
    signature: params.isSignatureActive
      ? Joi.string().required().messages({
          'any.required': 'INCOMPLETE_ERROR',
          'string.empty': 'INCOMPLETE_ERROR',
        })
      : Joi.optional(),
    differedDaysBeforeCirculation: Joi.when(Joi.ref('isDifferedCommunication'), {
      is: true,
      then: Joi.number().required().messages({
        'any.required': 'INCOMPLETE_DIFFERED_ERROR',
      }),
    }),
    differedCommunicationTime: Joi.when(Joi.ref('isDifferedCommunication'), {
      is: true,
      then: Joi.string().required().messages({
        'any.required': 'INCOMPLETE_DIFFERED_ERROR',
        'string.empty': 'INCOMPLETE_DIFFERED_ERROR',
      }),
    }),
  });
};

export default function (value: SendCommunicationSecondStepForm, params: Params) {
  return validate(
    schema({
      isReasonActive: params?.isReasonActive,
      isOthersReason: params?.isOthersReason,
      isVolumeDelay: params?.isVolumeDelay,
      isSubtitutionAndSchedule: params?.isSubtitutionAndSchedule,
      isDock: params?.isDock,
      isSignatureActive: params?.isSignatureActive,
    }),
    value,
    {
      context: {},
    },
    true
  );
}
